import styled from "@emotion/native";
import { Platform } from "react-native";
import _DrawerButton from "../../components/DrawerButton";
import Text from "../../components/Text";
import * as drawer from "../../utils/drawer";

export const Container = styled.View(
    {
        flex: 1,
    },
    ({ theme }: any) => {
        return {
            backgroundColor: theme.color.background,
        };
    },
);

export const Background = styled.Image({
    position: "absolute",
    width: "100%",
    height: "100%",
    resizeMode: "cover",
});

export const Scroll = styled.ScrollView({
    marginTop: drawer.BUTTON_TOP + drawer.BUTTON_HEIGHT + 18,
    overflow: Platform.OS === ("android" || "web") ? "scroll" : "visible",
});

Scroll.defaultProps = {
    contentContainerStyle: {
        flexGrow: 1,
    },
};

export const Title = styled(Text)({
    paddingHorizontal: 13,
    marginBottom: 38,
});

export const Intro = styled(Text)({
    paddingHorizontal: 12,
    marginBottom: 15,
});

export const IntroPrompt = styled(Text)({
    marginLeft: 12,
    marginTop: 11,
    marginBottom: 35,
});

export const ReviewPrompt = styled(Text)({
    marginLeft: 12,
    marginBottom: 26,
});

export const HeroText = styled(Text)(
    {
        marginTop: 4,
        marginLeft: 6,
        marginRight: 6,
    },
    ({ theme }: any) => {
        return { color: theme.color.text };
    },
);

export const SafetyStrategies = styled.View({
    height: 150,
    alignItems: "center",
});
export const SafetyStrategiesHeadline = styled(Text)({
    marginTop: 55,
    marginBottom: 30,
    marginLeft: 15,
});
